import { Component, OnInit, OnDestroy } from '@angular/core';
import { Expense, ExpenseService } from '..';
import { Subscription } from 'rxjs';
import { GlobalNamespace as _GlobalNS } from './../../../environments/environment';
import { GlobalService } from './../../core/global.service';

@Component({
  selector: 'app-expense-search',
  templateUrl: './expense-search.component.html',
  styleUrls: ['./expense-search.component.scss']
})
export class ExpenseSearchComponent implements OnInit, OnDestroy {
  expenseList: Expense [];
  loading = false;
  subscription: Subscription;
  searchCriteria: any;
  searchParams: any = {};
  totalRecords: number;

  constructor(private _expService: ExpenseService, private _globalSvc: GlobalService) { }

  ngOnInit() {
    this.loading = true;
    this.searchCriteria = this._globalSvc.find((<any>_GlobalNS).paths.expenseSearchCriteria);
    this.subscription = this._expService.find(this.convertSearchParams(this.searchCriteria))
      .subscribe((res: Expense[]) => {
          this.expenseList = (<any>res).data;
          this.searchParams.Offset = 1;
          this.searchParams.EndRow = this.expenseList.length;
          this.totalRecords = (<any>res).meta.pagination.TotalRecords;
          this.loading = false;
    });
  }

  expenseSearch (event): void {
    this.loading = true;
    this.searchParams = this.convertSearchParams(this.searchCriteria);
    this.searchParams.Offset = event.first + 1;
    this.searchParams.PageSize = event.rows;
    this.searchParams.EndRow = (this.searchParams.Offset + this.searchParams.PageSize) - 1;
    this.searchParams.SortValue = event.sortField ? event.sortField : 'CreateDate';
    this.searchParams.SortDir = (event.sortOrder === 1 || event.sortOrder === 'Asc') ? 'Asc' : 'Desc';

    this.subscription = this._expService.find(this.searchParams)
    .subscribe(res => {
      this.expenseList = (<any>res).data;
      this.totalRecords = (<any>res).meta.pagination.TotalRecords;
      this.loading = false;
    });
  }

  convertSearchParams(criteria): any {
    const params = {};
    for (const key in criteria) {
      if (key && criteria[key]) {
        if (criteria[key] !== null && criteria[key].length > 0) { params[key] = criteria[key]; }
      }
    }
    console.log(params);
    return params;
  }

  buildExcelUrl(): string {
    let uri = (<any>_GlobalNS).routes.expense.buildExcel;
    for (const key in this.searchCriteria) {
      if (key && this.searchCriteria[key]) {
        if (this.searchCriteria[key] !== null && this.searchCriteria[key].length > 0) {
          uri = uri + '&' + key + '=' + this.searchCriteria[key];
        }
      }
    }
    return uri;
  }

  propertyUrl(propertyId): string {
    return `${(<any>_GlobalNS).routes.property.viewTasks}&property_id=${propertyId}`;
  }

  ngOnDestroy() {
    if (this.subscription) { this.subscription.unsubscribe(); }
  }
}
